export const createSettingsSubscriptionRoutes = (basePath: string) =>
  ({
    index: basePath,
    invoices: {
      index: `${basePath}/invoices`,
    },
    activity: {
      index: `${basePath}/activity`,
    },
    paymentInfo: {
      index: `${basePath}/payment-info`,
    },
  }) as const;
